const api_key = localStorage.getItem("access_token") || "";
export const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/testimonios`;

/**
 * Obtiene los datos de un testimonio por ID en el idioma indicado.
 * @param {string|number} id - ID del testimonio.
 * @param {number} [lang=1] - LANGUAGE_ID para cargar NOMBRE/TEXTO de TESTIMONIOS_LANG.
 * @returns {Promise<Object>} - Datos del testimonio (ID, ACTIVO, POS, NOMBRE, TEXTO).
 */
export const fetchData = async (id, lang = 1) => {
  try {
    const url = lang != null ? `${BASE_URL}/${id}?lang=${lang}` : `${BASE_URL}/${id}`;
    const response = await fetch(url, {
      method: "GET",
      headers: { authToken: api_key },
    });
    if (!response.ok) throw new Error("Error al obtener los datos");
    return await response.json();
  } catch (error) {
    console.error("Error al obtener datos:", error);
    throw error;
  }
};

/**
 * Crea o actualiza un testimonio (maestro + fila en TESTIMONIOS_LANG).
 * Data debe incluir LANGUAGE_ID. Si Data.ID === 0, inserta; si ID > 0, actualiza.
 * @param {Object} Data - Campos: ID, ACTIVO, NOMBRE, TEXTO, POS, LANGUAGE_ID.
 * @returns {Promise<Response>}
 */
export const saveData = async (Data) => {
  try {
    const response = await fetch(`${BASE_URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authToken: api_key,
      },
      body: JSON.stringify({ ...Data }),
    });
    if (!response.ok) throw new Error("Error al guardar los datos");
    return response;
  } catch (error) {
    console.error("Error al guardar datos:", error);
    throw error;
  }
};

/** Lista de idiomas para el selector */
export const getLanguages = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/traducciones/getIdiomas`, {
      method: "GET",
      headers: { authToken: api_key },
    });
    if (!response.ok) throw new Error("Error al obtener idiomas");
    return await response.json();
  } catch (error) {
    console.error("Error al obtener idiomas:", error);
    throw error;
  }
};
